import axios from "axios";

export const getAllPriceHistory = async ({ listingId }) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/listing/${listingId}/price-history`;
  const response = await axios.get(url);
  return response.data;
};

export const setViewDetailEvent = async ({ listingId }) => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_API_HOSTNAME : process.env.EJ_APPS_API_HOSTNAME;
  const url = `${apiUrl}/e6t/v1/listing/${listingId}/view-detail`;
  await axios.get(url); // Burada yanıt kullanılmıyor.
};

export const getNearByListings = async (listingId) => {
  const url = `${process.env.EJ_APPS_SEARCH_API}/search/v1/listing/seo/${listingId}/near-by-listings`;
  const response = await axios.get(url);
  return response.data;
};

export const getSimilarRealEstate = async (listingId) => {
  const url = `${process.env.EJ_APPS_SEARCH_API}/search/v1/listing/same-real-estate/${listingId}?&limit=10`;
  const response = await axios.get(url);
  return response.data;
};
